import React, { FC } from 'react';
import styled from 'styled-components';

import { Match, Matches } from '../../../../../database.schema';
import { MatchPlayer } from './match-player';

const DropWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 20rem;
`;
const MatchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

type Props = {
  resultsHolder: Matches;
  playersPerTeam: number;
};

export const MatchEntryPairs: FC<Props> = ({ resultsHolder, playersPerTeam }): JSX.Element | null => {
  const matchHasSingles = playersPerTeam % 2 !== 0;
  const pairIndex = matchHasSingles ? 0 : 1;

  return (
    <div data-testid="match-pairs-entry">
      {resultsHolder.matches.map(
        (result: Match, index: number): JSX.Element => (
          <div key={`result-${index}`}>
            {matchHasSingles && result.team1.players.length === 1 ? (
              <div data-testid="sngles-entry">
                <h3>Singles Entry</h3>
                <div data-testid="match1">
                  <DropWrapper data-testid={`singles-${index}`}>
                    <MatchPlayer
                      dndId={`team1Single-${index}`}
                      playerId={resultsHolder.matches[index].team1.players?.[0].playerId}
                      team="team1-1"
                      bgColor="red"
                      matchIndex={index}
                    />
                    <MatchPlayer
                      dndId={`team2Single-${index}`}
                      playerId={resultsHolder.matches[index].team2.players?.[0].playerId}
                      team="team2-1"
                      bgColor="blue"
                      matchIndex={index}
                    />
                  </DropWrapper>
                </div>
              </div>
            ) : (
              <div data-testid="pairs-entry">
                <h3>Pairs Match {pairIndex + index}</h3>
                <DropWrapper data-testid={`drop-wrapper-${index}`}>
                  <MatchWrapper data-testid={`match1-wrapper-${index}`}>
                    <MatchPlayer
                      dndId={`team1PairPlayer1-${index}`}
                      playerId={resultsHolder.matches[index].team1.players?.[0].playerId}
                      team="team1-1"
                      bgColor="red"
                      matchIndex={index}
                    />
                    <MatchPlayer
                      dndId={`team2PairPlayer1-${index}`}
                      playerId={resultsHolder.matches[index].team2.players?.[0].playerId}
                      team="team2-1"
                      bgColor="blue"
                      matchIndex={index}
                    />
                  </MatchWrapper>
                  <MatchWrapper data-testid={`match2-wrapper-${index}`}>
                    <MatchPlayer
                      dndId={`team1PairPlayer2-${index}`}
                      playerId={resultsHolder.matches[index].team1.players?.[1].playerId}
                      team="team1-2"
                      bgColor="red"
                      matchIndex={index}
                    />
                    <MatchPlayer
                      dndId={`team2PairPlayer2-${index}`}
                      playerId={resultsHolder.matches[index].team2.players?.[1].playerId}
                      team="team2-2"
                      bgColor="blue"
                      matchIndex={index}
                    />
                  </MatchWrapper>
                </DropWrapper>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};
